import React, { useContext, useMemo, useState } from "react";
import style from "../anomaly.module.css";
import { AnomalyProvider, AnomalyContext } from "../cost-anomaly.context";
import AllCloudAnomalyHeader from "../components/all-cloud-anomalies-header.part";
import AllCloudIndividualGraph from "../components/all-cloud-anomalies-individual_graph";
import AllCloudStackedBarGraph from "../components/all-cloud-anomalies-stacked-bar-graph";

const AllCloudCostAnomaly = () => {
  return (
    <AnomalyProvider>
      <AllCloudCostAnomalyPage />
    </AnomalyProvider>
  );
};

export default AllCloudCostAnomaly;

const AllCloudCostAnomalyPage = () => {
  const context = useContext(AnomalyContext);
  const service = "all-cloud";


  return (
    <>
      <AllCloudAnomalyHeader service={service} />
      <AllCloudStackedBarGraph service={service}/>
      <AllCloudIndividualGraph service={service}/>
    </>
  );
};
